import {PurchaseCredit} from '@data/schema/loan-appication/purchase-credit';

export class DetailsOfTransaction {
  sAPurchasePrice: number;
  sBAlterations: number;
  sCLand: number;
  sDRefinance: number;
  sEEstimatedPrepaidItems: number;
  sFEstimatedClosingCost: number;
  sGPMIMIPFundingFee: number;
  sHDiscount: number;
  sJSubordinateFinancing: number;
  sKSellerPaidClosingCost: number;
  sCashFromToBorrower: number;
  sPurchaseCredit : PurchaseCredit[] = [];
  sPurchaseCreditType : string;


}
